import { render, staticRenderFns } from "./Taxis.vue?vue&type=template&id=745022e4&"
import script from "./Taxis.vue?vue&type=script&lang=js&"
export * from "./Taxis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports